import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTheme } from 'glamorous';
import StandardPageTemplate from '../../common/components/Layout/StandardPageTemplate';
import { LogoutMenuItem } from '../../common/components/Layout/Header/MenuConfig';
import FetchTiles from '../../common/components/FetchTiles';
import LandingView from '../../common/components/LandingView';
import LoadingView from '../../common/components/LoadingView';
import withCustomerOrg from '../../common/components/withCustomerOrg';
import { getCurrentUser } from '../../redux-modules/current-user';

class HomePage extends React.Component {
  static propTypes = {
    menuItems: PropTypes.array,
  };

  render() {
    const { colors } = this.props.theme;
    return (
      <StandardPageTemplate
        defaultDocTitle="Engage | NFIB"
        menuItems={this.props.menuItems}
      >
        <FetchTiles
          name="home"
          iconColorResolver={({ color }) => colors[color]}
        >
          {tiles => {
            if (!tiles || tiles.length === 0) {
              return <LoadingView />;
            }
            return <LandingView tiles={tiles} />;
          }}
        </FetchTiles>
      </StandardPageTemplate>
    );
  }
}

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);
  return {
    menuItems: currentUser && currentUser.id ? [LogoutMenuItem] : [],
  };
};

export default withCustomerOrg(connect(mapStateToProps)(withTheme(HomePage)));



// WEBPACK FOOTER //
// ./src/App/_root/HomePage.js